import { render, staticRenderFns } from "./ListEditor.vue?vue&type=template&id=4b58e2eb&scoped=true&"
import script from "./ListEditor.vue?vue&type=script&lang=js&"
export * from "./ListEditor.vue?vue&type=script&lang=js&"
import style0 from "./ListEditor.vue?vue&type=style&index=0&id=4b58e2eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b58e2eb",
  null
  
)

export default component.exports